module.exports = "https://cdn.dove.it/_next/static/public/assets/press/logo-wikicasanews.cafa93a61d9985b6066baf2ce64612f6.png";